import type { IntlShape } from 'react-intl'
import type { TripPlannerChat } from 'tripPlanner/api/types'
import tripPlannerGlossaryMessages from 'tripPlanner/i18n/tripPlannerGlossaryMessages'
import type { ClassicTripHistoryItem } from 'tripPlanner/legacyArchive/useClassicTripHistory'
import { CHAT_TRIP_PLANNER_PATH } from 'tripPlanner/config'
import { getTimestampSortValue } from 'tripPlanner/utils/chatTimestamps'
import { buildRecentAiChatItem, type RecentAiChatItem } from 'tripPlanner/utils/recentAiChatItem'

interface RecentClassicTripItem {
  type: 'classicTrip'
  id: string
  title: string
  subtitle?: string
  updatedAt: string
  sortTimestamp: number
  canManage?: boolean
}

export type RecentChatItem = RecentAiChatItem | RecentClassicTripItem

export function buildRecentChatItems(
  chats: Array<TripPlannerChat>,
  trips: Array<ClassicTripHistoryItem>,
): Array<RecentChatItem> {
  const aiChatItems: Array<RecentChatItem> = chats.map(buildRecentAiChatItem)

  const classicTripItems: Array<RecentChatItem> = trips.map((trip) => {
    const updatedAt = trip.updatedAt
    return {
      type: 'classicTrip',
      id: trip.id,
      title: trip.name,
      subtitle: trip.subtitle,
      updatedAt,
      sortTimestamp: getTimestampSortValue(trip.updatedAt),
      canManage: trip.canManage,
    }
  })

  return [...aiChatItems, ...classicTripItems].sort((a, b) => b.sortTimestamp - a.sortTimestamp)
}

export function getRecentChatItemUrl(item: RecentChatItem): string {
  if (item.type === 'aiChat') {
    return `${CHAT_TRIP_PLANNER_PATH}/${item.id}`
  }

  return `/trip-planner/trip/${encodeURIComponent(item.id)}/itinerary`
}

export function getRecentItemDisplayTitle(intl: IntlShape, title: string | undefined): string {
  return title?.trim() || intl.formatMessage(tripPlannerGlossaryMessages.untitled)
}
